const getSelectStyles = theme => ({
  marginBottom: theme.spacing(2),
  width: '100%',
  [theme.mediaQuery('tablet')]: {
    maxWidth: '500px',
    width: '250px'
  }
});

export { getSelectStyles };
//# sourceMappingURL=ServiceSortStyles.js.map
